var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifierOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "var(--ion-color-primary)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4073,17.7527 L14.9969,13.3422 C16.0587,11.9286 16.6319,10.208 16.63,8.44 C16.63,3.92406 12.9559,0.25 8.44,0.25 C3.92406,0.25 0.25,3.92406 0.25,8.44 C0.25,12.9559 3.92406,16.63 8.44,16.63 C10.208,16.6319 11.9286,16.0587 13.3422,14.9969 L17.7527,19.4073 C17.9759,19.6069 18.2671,19.7135 18.5664,19.7051 C18.8658,19.6967 19.1506,19.574 19.3623,19.3623 C19.574,19.1506 19.6967,18.8658 19.7051,18.5664 C19.7135,18.2671 19.6069,17.9759 19.4073,17.7527 Z M2.59,8.44 C2.59,7.28298 2.9331,6.15194 3.5759,5.18991 C4.21871,4.22789 5.13235,3.47808 6.2013,3.03531 C7.27025,2.59253 8.44649,2.47668 9.58128,2.70241 C10.7161,2.92813 11.7584,3.48529 12.5766,4.30343 C13.3947,5.12156 13.9519,6.16393 14.1776,7.29872 C14.4033,8.43351 14.2875,9.60975 13.8447,10.6787 C13.4019,11.7476 12.6521,12.6613 11.6901,13.3041 C10.7281,13.9469 9.59702,14.29 8.44,14.29 C6.88906,14.2881 5.40217,13.6712 4.30548,12.5745 C3.2088,11.4778 2.59186,9.99095 2.59,8.44 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierOutline);
export default __webpack_public_path__ + "static/media/magnifier-outline.3268a089c7f2a222818eaa127edc56cf.svg";
export { ForwardRef as ReactComponent };